import { IJSONSchemaProperty, SchemaFormat, SchemaType } from '../../integration-test-modal.types';

export const schemaFieldUtils = {
  isNestedObjectField: (property: IJSONSchemaProperty): boolean => {
    return property.type === SchemaType.OBJECT && Boolean(property.properties);
  },

  isNumericField: (property: IJSONSchemaProperty): boolean => {
    return property.type === SchemaType.NUMBER || property.type === SchemaType.INTEGER;
  },

  isPasswordField: (property: IJSONSchemaProperty): boolean => {
    return property.format === SchemaFormat.PASSWORD;
  },

  isUnknownObjectField: (property: IJSONSchemaProperty, value: unknown): boolean => {
    if (property.type) {
      return false;
    }
    return typeof value === 'object' || value === undefined || value === null;
  }
};
